module.exports = __webpack_public_path__ + "img/title2.d6c943a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/title2.png
// module id = YvaH
// module chunks = 15